


<div class="ttmodal">
    <div class="ttmodal__header">
      <span class="ttmodal__title">{{chartTitle| translate | async}}</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
    </div>
    <div class="ttmodal__body">
        <fleet-condition-widget *ngIf="showingChartId=='1'" [passedDataSource] = "passedDataSource"  [isInPopup] = 'true'></fleet-condition-widget>
        <inspections-performed-widget *ngIf="showingChartId=='2'"  [passedDataSource] = "passedDataSource" [isInPopup] = 'true' ></inspections-performed-widget>
        <cost-of-repairs-monthly-widget *ngIf="showingChartId=='3'"  [passedDataSource] = "passedDataSource" [isInPopup] = 'true' ></cost-of-repairs-monthly-widget>
        <components-on-eval-widget *ngIf="showingChartId=='5'" [passedDataSource] = "passedDataSource" [isInPopup] = 'true'  ></components-on-eval-widget>
        <app-inspections-due-widget *ngIf="showingChartId=='4'" [passedDataSource] = "passedDataSource"  [isInPopup] = 'true'></app-inspections-due-widget>
  </div>
  